import { DeviceInfo } from '../types/portal';

/**
 * 从URL中解析设备信息
 */
export function parseDeviceInfoFromUrl(): DeviceInfo | null {
  const params = new URLSearchParams(window.location.search);
  const deviceType = params.get('deviceType') as 'FULL_DUPLEX' | 'HALF_DUPLEX' | null;
  
  if (!deviceType || (deviceType !== 'FULL_DUPLEX' && deviceType !== 'HALF_DUPLEX')) {
    return null;
  }

  const deviceInfo: DeviceInfo = {
    deviceType,
  };

  // 解析所有可能的参数
  params.forEach((value, key) => {
    if (key !== 'deviceType') {
      deviceInfo[key] = value;
    }
  });

  return deviceInfo;
}

/**
 * 将设备信息编码为URL参数
 */
export function encodeDeviceInfoToParams(deviceInfo: DeviceInfo): string {
  const params = new URLSearchParams();
  
  Object.entries(deviceInfo).forEach(([key, value]) => {
    if (value) {
      params.append(key, value);
    }
  });

  return params.toString();
}

/**
 * 生成带设备信息的跳转链接
 * @param baseUrl 基础URL
 * @param deviceInfo 设备信息
 */
export function generateUrlWithDeviceInfo(baseUrl: string, deviceInfo: DeviceInfo): string {
  const params = encodeDeviceInfoToParams(deviceInfo);
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${params}`;
}

/**
 * 生成小程序跳转链接（用于服务号菜单跳转）
 * 格式：weixin://dl/business/?t=xxx&appid=xxx&path=xxx&query=xxx
 */
export function generateMiniprogramUrl(
  appId: string,
  path: string,
  deviceInfo: DeviceInfo
): string {
  const query = encodeDeviceInfoToParams(deviceInfo);
  // 注意：实际的小程序跳转链接格式可能需要根据微信文档调整
  // 这里提供一个基础格式
  return `weixin://dl/business/?appid=${appId}&path=${encodeURIComponent(path)}&query=${encodeURIComponent(query)}`;
}


